import { useRef, useState, useEffect } from "react";

export default function RevealOnScroll({ children, className = "", style = {} }) {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target); // animace jen jednou
          }
        });
      },
      { threshold: 0.025 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`${className} reveal ${isVisible ? "active" : ""}`}
      style={style} // <-- zde se propaguji styly
    >
      {children}
    </div>
  );
}
